// Helper function to format the time
const formatTime = (timestamp) => {
  const createdDate = new Date(timestamp);
  const now = new Date();
  const diffSeconds = Math.floor((now - createdDate) / 1000);

  if (diffSeconds < 60) {
    return `${diffSeconds} second${diffSeconds !== 1 ? 's' : ''} ago`;
  } else if (diffSeconds < 3600) {
    const minutes = Math.floor(diffSeconds / 60);
    return `${minutes} minute${minutes !== 1 ? 's' : ''} ago`;
  } else if (diffSeconds < 86400) {
    const hours = Math.floor(diffSeconds / 3600);
    return `${hours} hrs ago`;
  } else {
    // For posts older than 24 hours, display full date and time
    return createdDate.toLocaleString();
  }
};

export default formatTime;
